<template>
  <div class="footer-container">
    <div class="footer-content">
      <span class="footer-title" style="cursor: pointer;" @click="toAbout">关于我们</span>
      <!-- <router-link class="footer-title" target="_blank" to="/about"></router-link> -->
      <span class="footer-title" style="cursor: pointer;" @click="toOpinion">意见反馈</span>
      <span class="footer-title" style="cursor: pointer;" @click="toApptcp">《使用协议》</span>
      <span class="footer-title" style="cursor: pointer;" @click="toUserAgreement">《隐私政策》</span>
      <span class="footer-title">互联网出版许可证：新出网证（京）字277号 </span>
      <span class="footer-title">© 2017 - 2024 中文集团数字出版传媒股份有限公司</span>
      <span class="footer-title"
        ><a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff"
          >京ICP备13001908号-2</a
        ></span
      >
      <span class="footer-title">京ICP证 140746号</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["hasLogin"]),
  },
  methods: {
    toAbout() {
      let routeUrl = this.$router.resolve({
        path: "/about",
      });
      window.open(routeUrl .href, '_blank');
    },
    toOpinion() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let routeUrl = this.$router.resolve({
        path: "/opinion",
      });
      window.open(routeUrl .href, '_blank');
    },
    toUserAgreement(){
      let routeUrl = this.$router.resolve({
        path: "/mPAgreement"
      })
      window.open(routeUrl .href, '_blank')
    },
    toApptcp(){
      let routeUrl = this.$router.resolve({
        path: "/apptcp"
      })
      window.open(routeUrl .href, '_blank')
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  // position: fixed;
  // bottom:0;
  // left:0;
  width: 100%;
  height: 80px;
  background-color: #007fff;
  color: #fff;
  user-select: none;
  margin-top: 21px;
  .footer-content {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    line-height: 80px;
    font-size: 12px;
  }
  .footer-title {
    color: #fff
  }
}
</style>
